"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = exports.JoinComponent = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _JoinComponent = require("./JoinComponent.styled");
var _Settings = require("./Settings");
var _SystemCheck = require("./SystemCheck");
var _Notification = require("../Notification");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _readinessCheck = require("../../constants/readinessCheck");
var _constants = require("@studio/constants");
var _utils = require("./utils");
var _logger = require("@studio/logger");
var _constants2 = require("../../constants");
var _feature = require("@studio/feature.flags");
var _chime = require("@studio/chime");
var _useNotification3 = require("../../hooks/useNotification");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var logger = exports.logger = new _logger.StudioLogger('JoinPage');
var JoinComponent = exports.JoinComponent = function JoinComponent(_ref) {
  var sourceLoadStatus = _ref.sourceLoadStatus,
    retryReadinessCheck = _ref.retryReadinessCheck,
    readinessCheck = _ref.readinessCheck,
    meetingSession = _ref.meetingSession,
    joinMeeting = _ref.joinMeeting,
    user = _ref.user,
    removeSandboxMeetingAttendee = _ref.removeSandboxMeetingAttendee,
    startCheck = _ref.startCheck,
    userRole = _ref.userRole,
    sandboxMeetingSession = _ref.sandboxMeetingSession,
    _ref$isStandaloneChec = _ref.isStandaloneChecker,
    isStandaloneChecker = _ref$isStandaloneChec === void 0 ? false : _ref$isStandaloneChec,
    uploadUserVirtualBackground = _ref.uploadUserVirtualBackground,
    deleteUserVirtualBackground = _ref.deleteUserVirtualBackground,
    resetUserVirtualBackground = _ref.resetUserVirtualBackground,
    _ref$shouldJoinWithou = _ref.shouldJoinWithoutKnock,
    shouldJoinWithoutKnock = _ref$shouldJoinWithou === void 0 ? false : _ref$shouldJoinWithou;
  var _useState = (0, _react.useState)(user === null || user === void 0 ? void 0 : user.firstName),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    firstName = _useState2[0],
    setFirstName = _useState2[1];
  var _useState3 = (0, _react.useState)(user === null || user === void 0 ? void 0 : user.lastName),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    lastName = _useState4[0],
    setLastName = _useState4[1];
  var presenterTitle = "".concat(firstName, " ").concat(lastName);
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    hasRun = _useState6[0],
    setHasRun = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    selectedVideoInputId = _useState8[0],
    setSelectedVideoInputId = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    selectedAudioInputId = _useState10[0],
    setSelectedAudioInputId = _useState10[1];
  var _useState11 = (0, _react.useState)(''),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    selectedAudioOutputId = _useState12[0],
    setSelectedAudioOutputId = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    errors = _useState14[0],
    setErrors = _useState14[1];
  var _useState15 = (0, _react.useState)([]),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    warnings = _useState16[0],
    setWarnings = _useState16[1];
  var _useState17 = (0, _react.useState)(''),
    _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
    presenterDescription = _useState18[0],
    setPresenterDescription = _useState18[1];
  var _useState19 = (0, _react.useState)(_constants.BACKGROUND_OPTIONS.NONE),
    _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
    userBackground = _useState20[0],
    setUserBackground = _useState20[1];
  var shouldRequireAudio = (0, _feature.shouldHaveFeature)('studio.requireAudio');
  var isDDSynthetics = window._DATADOG_SYNTHETICS_BROWSER === true;
  var _useState21 = (0, _react.useState)(null),
    _useState22 = (0, _slicedToArray2["default"])(_useState21, 2),
    videoInput = _useState22[0],
    setVideoInput = _useState22[1];
  var _useState23 = (0, _react.useState)(null),
    _useState24 = (0, _slicedToArray2["default"])(_useState23, 2),
    transformedVideoInput = _useState24[0],
    setTransformedVideoInput = _useState24[1];
  var _useNotification = (0, _useNotification3.useNotification)(),
    _useNotification2 = (0, _slicedToArray2["default"])(_useNotification, 2),
    notification = _useNotification2[0],
    showNotification = _useNotification2[1];
  var _useState25 = (0, _react.useState)(_constants2.joinPageStatus.IN_PROGRESS),
    _useState26 = (0, _slicedToArray2["default"])(_useState25, 2),
    checkStatus = _useState26[0],
    setCheckStatus = _useState26[1];
  var completedCheckList = _objectSpread(_objectSpread({}, readinessCheck), {}, {
    microphone: shouldRequireAudio ? readinessCheck.microphone : _readinessCheck.PASSED
  });
  delete completedCheckList.screenShare;
  delete completedCheckList.speaker;
  var pages = {
    SETTINGS: 'settings',
    SYSTEM_CHECK: 'system-check'
  };
  var virtualBackground = user === null || user === void 0 ? void 0 : user.virtualBackground;
  var _useState27 = (0, _react.useState)(pages.SETTINGS),
    _useState28 = (0, _slicedToArray2["default"])(_useState27, 2),
    currentPage = _useState28[0],
    setCurrentPage = _useState28[1];
  (0, _react.useEffect)(function () {
    if (sandboxMeetingSession !== null) {
      runTest();
    }
  }, [sandboxMeetingSession]);
  (0, _react.useEffect)(function () {
    var _notification = {
      message: '',
      linkMessage: ''
    };
    var errors = (0, _utils.getErrorMessages)(completedCheckList);
    var warnings = (0, _utils.getWarningMessages)(completedCheckList);
    setErrors(errors);
    setWarnings(warnings);
    var allChecksDone = Object.values(completedCheckList).every(function (value) {
      return value !== _readinessCheck.CHECKING;
    });
    if (allChecksDone) {
      logger.info("Attendee Readiness Check: ".concat(presenterTitle, ": ").concat(JSON.stringify(_objectSpread({}, readinessCheck))));
    }
    var isAudioPermissionDenied = readinessCheck.microphone === _readinessCheck.PERMISSION_DENIED;
    if (isAudioPermissionDenied) {
      setCheckStatus(_constants2.joinPageStatus.BROWSER_BLOCK);
      setCurrentPage(pages.SETTINGS);
    }
    if (errors.length > 0) {
      setCheckStatus(_constants2.joinPageStatus.ERROR);
    }
    if (allChecksDone && checkStatus === _constants2.joinPageStatus.IN_PROGRESS && errors.length === 0) {
      setCheckStatus(_constants2.joinPageStatus.COMPLETE);
    }
    var notificationStatus = (0, _utils.getNotificationStatus)(completedCheckList, userRole, isStandaloneChecker, shouldJoinWithoutKnock);
    showNotification(_constants2.notificationMap[notificationStatus] || _notification);
  }, [readinessCheck, setCurrentPage, checkStatus, currentPage]);
  (0, _react.useEffect)(function () {
    if (virtualBackground !== null && virtualBackground !== void 0 && virtualBackground.isDeleteFailed) {
      showNotification({
        message: _constants.DELETE_VIRTUAL_BACKGROUND_FAILURE_MSG,
        type: 'warning',
        linkMessage: '',
        delay: 3000,
        onClick: function onClick() {}
      });
      resetUserVirtualBackground();
    }
  }, [virtualBackground === null || virtualBackground === void 0 ? void 0 : virtualBackground.isDeleteFailed]);
  var goToSettings = function goToSettings() {
    setCheckStatus(_constants2.joinPageStatus.PENDING);
    setCurrentPage(pages.SETTINGS);
  };
  var goToSystemCheck = function goToSystemCheck() {
    setCurrentPage(pages.SYSTEM_CHECK);
  };
  var _useState29 = (0, _react.useState)([]),
    _useState30 = (0, _slicedToArray2["default"])(_useState29, 2),
    audioOutputDevices = _useState30[0],
    setAudioOutputDevices = _useState30[1];
  (0, _chime.useAudioVideoDevice)({
    meetingSession: meetingSession,
    setDevices: setAudioOutputDevices,
    onDeviceChanged: setSelectedAudioOutputId,
    selectedDeviceId: selectedAudioOutputId,
    deviceType: _constants.AUDIO_OUTPUT
  });
  var runTest = function runTest() {
    setCheckStatus(_constants2.joinPageStatus.IN_PROGRESS);
    setHasRun(true);
    logger.info("Attendee: ".concat(presenterTitle, " initiated a readiness check"));
    hasRun ? retryReadinessCheck() : startCheck();
  };
  var handleJoinMeeting = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
      var transformedVideoInputs, payload;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            logger.info("Attendee Joined ".concat(presenterTitle));
            _context.next = 4;
            return (0, _utils.handleTransformedVideoInput)(userBackground, transformedVideoInput, setTransformedVideoInput);
          case 4:
            transformedVideoInputs = _context.sent;
            payload = {
              audioInputDeviceId: selectedAudioInputId,
              audioOutputDeviceId: selectedAudioOutputId,
              videoInputDeviceId: selectedVideoInputId,
              presenterTitle: presenterTitle,
              presenterDescription: presenterDescription,
              userBackground: userBackground,
              videoInput: videoInput,
              transformedVideoInputs: transformedVideoInputs,
              notification: notification
            };
            joinMeeting(payload);
            logger.info("Attendee joined meeting: ".concat(presenterTitle, ": ").concat(JSON.stringify(_objectSpread({}, readinessCheck))));
            removeSandboxMeetingAttendee();
            // stop the video input stream for sandbox session
            if (videoInput) {
              (0, _chime.stopVideoInput)(meetingSession);
            }
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleJoinMeeting(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleVideoInputChange = (0, _react.useCallback)(function (videoInput) {
    var _videoInput$device;
    setSelectedVideoInputId((_videoInput$device = videoInput === null || videoInput === void 0 ? void 0 : videoInput.device) !== null && _videoInput$device !== void 0 ? _videoInput$device : videoInput);
    setVideoInput(videoInput);
  }, []);
  var onTransformedVideoInputChange = (0, _react.useCallback)(function (transformedVideoInput) {
    setTransformedVideoInput(transformedVideoInput);
  }, []);
  var content = null;
  if (currentPage === pages.SETTINGS) {
    var checkInProgress = checkStatus === _constants2.joinPageStatus.IN_PROGRESS;
    var browserBlock = checkStatus === _constants2.joinPageStatus.BROWSER_BLOCK;
    var hasTitle = presenterTitle.trim().length > 0;
    var hasError = checkStatus === _constants2.joinPageStatus.ERROR;
    var hasFirstNameExceededLimit = firstName.trim().length > 30;
    var hasLastNameExceededLimit = lastName.trim().length > 50;
    var hasDescriptionExceededLimit = presenterDescription.trim().length > 80;
    // There is a moment where the readiness check for microphone is complete but the audio device is not yet set.
    // This is apparent more so on windows/lower end devices.
    var hasAudioDevice = selectedAudioInputId !== '' || !shouldRequireAudio;
    var hasValidationError = !hasTitle || hasFirstNameExceededLimit || hasLastNameExceededLimit || hasDescriptionExceededLimit;
    var sourcesNotReady = sourceLoadStatus !== _constants.DONE && userRole === _constants.SOURCE_ROLE_HOST;
    var isJoinButtonDisabled = sourcesNotReady || checkInProgress || browserBlock || hasValidationError || hasError || !hasAudioDevice;
    //We need to have synthetics wait until sources are loaded!
    if (isDDSynthetics && !sourcesNotReady) {
      isJoinButtonDisabled = false;
    }
    var isCheckSystemButtonDisabled = checkInProgress || browserBlock || hasValidationError;
    var footer = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.CheckSystemButton, {
      onClick: goToSystemCheck,
      color: "outline",
      disabled: isCheckSystemButtonDisabled,
      "data-testid": "check_system_button"
    }, "Check system"), !isStandaloneChecker && /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledJoinButton, {
      disabled: isJoinButtonDisabled,
      onClick: handleJoinMeeting,
      color: "primary",
      "data-testid": "join_button"
    }, "Join"));
    content = /*#__PURE__*/_react["default"].createElement(_Settings.Settings, {
      user: _objectSpread(_objectSpread({}, user), {}, {
        firstName: firstName,
        lastName: lastName
      }),
      selectedVideoInputId: selectedVideoInputId,
      selectedAudioInputId: selectedAudioInputId,
      selectedAudioOutputId: selectedAudioOutputId,
      meetingSession: meetingSession,
      audioOutputDevices: (0, _utils.formatDevicesArrayForDropdown)(audioOutputDevices),
      onVideoInputChange: handleVideoInputChange,
      onAudioInputChange: setSelectedAudioInputId,
      onAudioOutputChange: function onAudioOutputChange(deviceId) {
        return setSelectedAudioOutputId(deviceId);
      },
      onPresenterDescriptionChange: setPresenterDescription,
      isAudioPermissionDenied: readinessCheck.microphone === _readinessCheck.PERMISSION_DENIED,
      isVideoPermissionDenied: readinessCheck.camera === _readinessCheck.PERMISSION_DENIED,
      footer: footer,
      presenterDescription: presenterDescription,
      checkStatus: checkStatus,
      transformedVideoInput: transformedVideoInput,
      onTransformedVideoInputChange: onTransformedVideoInputChange,
      virtualBackground: virtualBackground,
      userBackground: userBackground,
      setUserBackground: setUserBackground,
      uploadUserVirtualBackground: uploadUserVirtualBackground,
      deleteUserVirtualBackground: deleteUserVirtualBackground,
      resetUserVirtualBackground: resetUserVirtualBackground,
      handleFirstNameChange: setFirstName,
      handleLastNameChange: setLastName
    });
  } else if (currentPage === pages.SYSTEM_CHECK) {
    content = /*#__PURE__*/_react["default"].createElement(_SystemCheck.SystemCheck, {
      runSystemCheck: runTest,
      joinMeeting: handleJoinMeeting,
      goBack: goToSettings,
      errors: errors,
      warnings: warnings,
      checkStatus: checkStatus,
      isStandaloneChecker: isStandaloneChecker
    });
  }
  var noErrorOrWarning = errors.length === 0 && warnings.length === 0;
  return /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCard, {
    className: "shadow-sm",
    "data-testid": "join-page"
  }, /*#__PURE__*/_react["default"].createElement(_JoinComponent.NotificationComponentWrapper, {
    "data-testid": "join_notification".concat(noErrorOrWarning ? '_success' : '')
  }, notification.message !== '' && /*#__PURE__*/_react["default"].createElement(_Notification.Notification, (0, _extends2["default"])({
    key: notification.id
  }, notification))), content);
};
JoinComponent.propTypes = {
  retryReadinessCheck: _propTypes["default"].func.isRequired,
  sourceLoadStatus: _propTypes["default"].string,
  readinessCheck: _propTypes["default"].object.isRequired,
  meetingSession: _propTypes["default"].object,
  joinMeeting: _propTypes["default"].func.isRequired,
  user: _propTypes["default"].object.isRequired,
  removeSandboxMeetingAttendee: _propTypes["default"].func.isRequired,
  startCheck: _propTypes["default"].func.isRequired,
  description: _propTypes["default"].string,
  userRole: _propTypes["default"].oneOf([_constants.SOURCE_ROLE_HOST, _constants.SOURCE_ROLE_SPEAKER]),
  sandboxMeetingSession: _propTypes["default"].object,
  uploadUserVirtualBackground: _propTypes["default"].func,
  deleteUserVirtualBackground: _propTypes["default"].func
};